// FE/src/utils/frontendConfig.js
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_URL ||
  'https://uatworksphere.agnocon.com/backend';
